import { TypedUseSelectorHook, useDispatch, useSelector, useStore } from 'react-redux';

import { AppDispatch, AppStore, RootState } from '../store-tmp';
// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppStore = useStore.withTypes<AppStore>();
